import { useQuery } from "@tanstack/react-query";
import { courseRegistrationApi } from "api/registrations";

export const useRegistrationId = (userId: number, courseId: number) => {
  const { isLoading, data, refetch } = useQuery({
    queryKey: ["registrationId", userId, courseId],
    queryFn: async () => {
      const registrationId = await courseRegistrationApi.getRegistrationId(courseId, userId);
      return registrationId;
    },
    enabled: !!userId && !!courseId,
  });

  return { loading: isLoading, data, refetch };
};
